export default "__VITE_ASSET__f85883ef__"